import React from "react";
import { Container, HeroSection } from "./styled";
import { Link } from "react-router-dom";
import styles from "../../styles/Home.module.scss";
import { SuscriptionsPackages } from "../../components";

const Main = () => {
  return (
    <Container>
      <div className="hero">
        <div className="hero-content-container">
          <h1 className={styles.dynamicTitle}>
            Impulsa{" "}
            <span>
              Tu <br />
              Equipo
            </span>{" "}
            con <br /> Datos Precisos
          </h1>
          <p>
            Descubre estadísticas y análisis detallados para llevar tu juego de
            baloncesto al siguiente nivel. Mejora tu rendimiento y toma
            decisiones informadas con nuestra plataforma avanzada.
          </p>
          <Link to="/app/register" className="btn-primary">
            Empezá gratis
          </Link>
        </div>
        <div className="hero-images-container">
          <img
            className="image"
            src="/assets/hero-image.png"
            alt="deportactico logo"
            loading="lazy"
          />
        </div>
      </div>
      {/*  ADD SOCIAL PROOF
      <div className="separetion-section"></div> */}
      <div className="t-section">
        <div className="t-section-extra">
          <div className="content-container">
            <h2 className={styles.dynamicHeader}>
              Informes de Rendimiento <br />
              De Equipos
            </h2>
            <p>
              Obtén estadísticas y análisis detallados sobre el desempeño de +55
              euqipos de Liga Nacional y Liga Argentina durante cada partido y a
              lo largo de la temporada. Nuestros informes te proporcionan
              información clave para identificar fortalezas y áreas de mejora,
              ayudándote a ajustar estrategias y tácticas con datos precisos.
              Mejora el rendimiento colectivo y optimiza la preparación para
              cada encuentro.
            </p>
            <Link to="/app/register" className="btn-primary">
              Empezá gratis
            </Link>
          </div>
          <div className="image-container">
            <img
              className="court-image"
              src="/assets/team-value.jpg"
              alt="deportactico logo"
              loading="lazy"
            />
          </div>
        </div>
      </div>
      <div className="t-section">
        <div className="t-section-extra revesed">
          <div className="content-container">
            <h2 className={styles.dynamicHeader}>
              Informes De Rendimiento <br />
              De Jugadores
            </h2>
            <p>
              Analiza el rendimiento individual de cada jugador con nuestras
              herramientas avanzadas de estadísticas y análisis. Desde puntos y
              rebotes hasta eficiencia y rendimiento defensivo, nuestros
              informes te permiten conocer en profundidad el desarrollo de cada
              atleta. Utiliza esta información para tomar decisiones informadas
              y maximizar el potencial de cada jugador.
            </p>
            <Link to="/app/register" className="btn-primary">
              Empezá gratis
            </Link>
          </div>
          <div className="image-container">
            <img
              className="court-image"
              src="/assets/player-value.jpg"
              alt="deportactico logo"
              loading="lazy"
            />
          </div>
        </div>
      </div>
      <div className="t-section ">
        <div className="t-section-extra ">
          <div className="content-container">
            <h2 className={styles.dynamicHeader}>Playbook</h2>
            <p>
              Nuestra herramienta de playbook te permite crear y visualizar
              jugadas tácticas de forma dinámica y sencilla. Crea animaciones
              personalizadas para explicar estrategias de ataque y defensa a tu
              equipo. Esta herramienta está diseñada para entrenadores que
              buscan una forma visual y efectiva de comunicar las jugadas y
              mejorar la ejecución en la cancha.
            </p>
            <Link to="/app/register" className="btn-primary">
              Empezá gratis
            </Link>
          </div>
          <div className="image-container">
            <img
              className="court-image"
              src="/assets/playbook.jpg"
              alt="deportactico logo"
              loading="lazy"
            />
          </div>
        </div>
      </div>
      <div className="t-section pinkBackground">
        <div className="t-section-extra revesed">
          <div className="content-container">
            <h2 className={styles.dynamicHeader}>Nuestra Mision</h2>
            <p>
              En nuestra plataforma, nos dedicamos a potenciar el rendimiento de
              equipos y jugadores de baloncesto a través del uso de estadísticas
              y análisis avanzados. Nuestra misión es brindar herramientas
              innovadoras que faciliten la toma de decisiones informadas y
              estratégicas, ayudando a entrenadores y jugadores a alcanzar su
              máximo potencial. Creemos en el poder de los datos para
              transformar el juego y llevarlo al siguiente nivel.
            </p>
            <Link to="/app/register" className="btn-primary">
              Empezá gratis
            </Link>
          </div>
          <div className="image-container">
            <img
              className="court-image"
              src="/assets/mision-image.png"
              alt="deportactico logo"
              loading="lazy"
            />
          </div>
        </div>
      </div>
      <div className="packages-section">
        <h2 className={styles.dynamicHeader}>
          Impulsa Tu Equipo y Maximiza Su Rendimiento Con Nuestras Suscripciones
        </h2>
        <SuscriptionsPackages />
      </div>
      {/* ADD TESTIMONIOS */}
      <div className="contact-section">
        <h2 className={styles.dynamicHeader}>
          ¡Ponte en contacto <br />y hablemos!
        </h2>
        <div>
          <p>
            ¿Tienes preguntas o necesitas más información sobre cómo nuestras
            herramientas pueden ayudarte a mejorar el rendimiento de tu equipo?
            ¡Nos encantaría conversar contigo! Ponte en contacto con nosotros
            para hablar sobre tus necesidades y cómo podemos ofrecerte
            soluciones personalizadas que se adapten a tus objetivos. ¡Estamos
            aquí para ayudarte a triunfar!
          </p>
          <Link to="/contact" className="btn-primary">
            Contactanos
          </Link>
        </div>
      </div>
    </Container>
  );
};

export default Main;
